// extracted by mini-css-extract-plugin
export default {"container":"myCourses_container__TmiJB","divider":"myCourses_divider__9W2+a","mobile":"myCourses_mobile__ca3du","title":"myCourses_title__dKzA1","line":"myCourses_line__qzJDS"};